<template>
  <b-overlay
    :show="loader.planes"
    rounded="sm"
  >
    <b-card no-body>
      <b-card-body>
        <b-row>
          <!-- plan de estudios -->
          <b-col
            cols="6"
            md="6"
            class="amg"
          >
            <label>Especialidades</label>
            <v-select
              style="text-overflow: ellipsis;"
              :value="planFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="planes"
              class="w-100"
              size="sm"
              label="nombre"
              :reduce="pln => pln.id"
              @input="(pln) => aplyfilterplan(pln)"
            />
          </b-col>
          <!-- fecha de inicio  -->
          <b-col
            cols="2"
            md="2"
            class="amg"
          >
            <b-form-group
              label="Fecha Inicio [ 2024-01-01 ]"
              label-for="fechaFiltro"
              class="mb-2"
            >
              <flat-pickr
                id="fechaFiltro"
                v-model="lcfromFilter"
                class="form-control"
                size="sm"
                @on-close="aplyfilterfrom()"
              />
            </b-form-group>
          </b-col>
          <!-- cuatrimestres / periodos -->
          <b-col
            cols="2"
            md="2"
            class="amg"
          >
            <label>Cuatrimestres</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="cuatriFilter"
              :options="cuatrimestres"
              class="w-100"
              size="sm"
              :reduce="per => per.orden"
              @input="(per) => aplyPeriodo(per)"
            >
              <template #no-options>
                <em style="opacity: 0.5;">No hay cuatrimestres disponibles</em>
              </template>
              <template #option="option">
                <span class="CheckIcon" />
                {{ option.temporalidad }}  {{ (option.orden != 0) ? option.orden : '' }}
              </template>
              <!-- Como se ve la opción seleccionada -->
              <template #selected-option="{ orden, temporalidad }">
                <div style="display: flex; align-items: baseline;">
                  <b>{{ temporalidad }} </b><em style="margin-left: .5rem;">  {{ (orden != 0) ? orden : '' }}   </em>
                </div>
              </template>
            </v-select>
          </b-col>
          <!-- estatus -->
          <b-col
            cols="2"
            md="2"
          >
            <label>Estatus</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="statusFilter"
              :options="statusOptions"
              class="w-100"
              size="sm"
              :reduce="val => val.value"
              @input="(val) => $emit('update:statusFilter', val || null)"
            />
          </b-col>
        </b-row>
      </b-card-body>
      <template #footer>
        <em>Total: <b>{{ totalsolicitudes }}</b> registros / {{ (monthsdiff | 0) }} meses, apartir de {{ finicio }}</em>
      </template>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard,
  // BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BOverlay,
  BFormGroup,
} from 'bootstrap-vue'
import { lastUpdate } from '@core/utils/filter'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import {
  ref, onMounted, watch,
} from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { listaPlanes, listaCuatrimestres } from '../useCompras'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    // BCardHeader,
    BCardBody,
    vSelect,
    BOverlay,
    flatPickr,
    BFormGroup,
  },
  props: {
    planFilter: {
      type: [Number, null],
      default: null,
    },
    statusFilter: {
      type: [String, null],
      default: null,
    },
    cuatriFilter: {
      type: [Number, null],
      default: null,
    },
    fromFilter: {
      type: [String, null],
      default: null,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    totalsolicitudes: {
      type: [Number],
      default: 0,
    },
    finicio: {
      type: [String, null],
      default: null,
    },
  },
  data() {
    return {
      periodos: [],
    }
  },
  setup(props, { emit }) {
    const cuatrimestres = ref([])
    const planes = ref([])
    const lcfromFilter = ref(null)
    const istoday = ref(null)
    istoday.value = new Date()
    // const planFilter = ref(null)
    const loader = ref({ planes: false, cuatrimestres: false, status: false })
    const toast = useToast()
    const updatedAt = ref(lastUpdate())
    const monthsdiff = ref(null)

    const monthDiff = (d1, d2) => {
      let months
      months = (d2.getFullYear() - d1.getFullYear()) * 12
      months -= d1.getMonth()
      months += d2.getMonth()
      return months <= 0 ? 0 : months
    }

    watch(() => props.finicio, chnval => {
      const fini = new Date(`${chnval}T03:24:00`)
      monthsdiff.value = monthDiff(fini, new Date())
    })

    // cuatrimestres x plan
    const cuatrisxPlan = Idplan => {
      if (Idplan != null) {
        loader.value.cuatrimestres = true
        listaCuatrimestres(Idplan)
          .then(response => {
            cuatrimestres.value = response.data
            cuatrimestres.value.push({
              orden: 0, temporalidad: 'Mostrar Todo',
            })
            // cuatrimestres.value.reverse()
            loader.value.cuatrimestres = false
            emit('reloadApi')
          })
          .catch(error => {
            loader.value.cuatrimestres = false
            toast({
              component: ToastificationContent,
              props: {
                title: 'Atención',
                text: `${error}.`,
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            },
            { timeout: 10000 })
          })
      } else {
        cuatrimestres.value = []
      }
    }

    const aplyPeriodo = item => {
      emit('update:cuatriFilter', item || 0)
      emit('update:statusFilter', null)
      emit('reloadApi')
    }

    // CHANGE PLAN
    const aplyfilterplan = item => {
      // debido que puede o no tener un plan seleccionado los demas filtros deben ser reseteados
      emit('update:planFilter', item || 0)
      emit('update:cuatriFilter', 0)
      emit('update:fromFilter', null)
      emit('update:statusFilter', null)
      cuatrisxPlan(item)
    }

    // aplica la fecha del filtro customn
    const aplyfilterfrom = () => {
      emit('update:fromFilter', lcfromFilter)
      emit('update:cuatriFilter', 0)
      emit('update:statusFilter', null)
      emit('reloadApi')
    }

    // lista de planes para filtrar los cuatrimestres
    const loadPlanes = () => {
      loader.value.planes = true
      listaPlanes()
        .then(response => {
          planes.value = response.data
          loader.value.planes = false
          lcfromFilter.value = props.fromFilter
          cuatrisxPlan(props.planFilter)
        })
        .catch(error => {
          loader.value.planes = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [Planes]',
              text: `${error} Intente de nuevo por favor.`,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    onMounted(() => {
      // obtiene fecha de inicio
      istoday.value.setMonth(istoday.value.getMonth() - 1)
      istoday.value.setDate(1)
      // lcfromFilter.value = istoday.value.toISOString().slice(0, 10)
      loadPlanes()
      // loadPeriodos()
    })

    return {
      // datos
      cuatrimestres,
      planes,
      loader,
      lcfromFilter,
      istoday,

      // tareas
      cuatrisxPlan,
      aplyPeriodo,
      aplyfilterplan,
      aplyfilterfrom,
      monthsdiff,
      // actions
      monthDiff,
      updatedAt,
    }
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
